const {iframe} = window.YC;

const redirectToExternalUrl = (url: string, keepIframe?: boolean) => {
    if (iframe && !keepIframe) {
        window.parent.location.href = url;
    } else {
        window.location.href = url;
    }
};
export default redirectToExternalUrl;
